import classNames from 'classnames';
import * as React from 'react';

import * as styles from './BrandingLevelWrapper.css';
import { EBrandingLevel } from '../../types/offer';

interface IBrandingLevelWrapperProps {
  brandingLevel: EBrandingLevel | null;
}

export const BrandingLevelWrapper: React.FC<React.PropsWithChildren<IBrandingLevelWrapperProps>> = ({
  brandingLevel,
  children,
}) => {
  const isPlatinum = brandingLevel === EBrandingLevel.ThirdLevel;
  const className = classNames(styles['branding-level-wrapper'], {
    [styles['platinum']]: isPlatinum,
  });

  return (
    <div className={className} data-branding-level={isPlatinum ? 'platinum' : undefined}>
      {children}
    </div>
  );
};
